export default __webpack_public_path__ + "FinSuite-logo.e29a21e1.png";